"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _usePalette = _interopRequireDefault(require("../usePalette"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  color: inherit;\n  margin: 4px;\n  font-size: inherit;\n  cursor: pointer;\n\n  &::disabled {\n    opacity: 0.6;\n    cursor: normal;\n  }\n\n  &.pui-checkbox--size-small {\n    font-size: 12px;\n  }\n\n  &.pui-checkbox--size-normal {\n    font-size: 14px;\n  }\n\n  &.pui-checkbox--size-medium {\n    font-size: 16px;\n  }\n\n  &.pui-checkbox--size-large {\n    font-size: 20px;\n  }\n\n  &.pui-checkbox--size-inherit {\n    font-size: inherit;\n  }\n\n  &.pui-checkbox--color-default {\n    color: #888888;\n  }\n\n  &.pui-checkbox--color-inherit {\n    color: inherit;\n  }\n\n  &.pui-checkbox--checked {\n  }\n\n  &.pui-checkbox--disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n\n  &.pui-checkbox--no-margin {\n    margin: 0px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CheckboxRoot = _styledComponents["default"].div(_templateObject());

var CheckboxBox = function CheckboxBox(_ref) {
  var checked = _ref.checked,
      props = _objectWithoutProperties(_ref, ["checked"]);

  if (Boolean(!checked)) {
    return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, _extends({}, props, {
      icon: _freeRegularSvgIcons.faSquare
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, _extends({}, props, {
    icon: _freeSolidSvgIcons.faCheckSquare
  }));
};

var Checkbox = function Checkbox(_ref2) {
  var className = _ref2.className,
      color = _ref2.color,
      size = _ref2.size,
      checked = _ref2.checked,
      style = _ref2.style,
      disabled = _ref2.disabled,
      onChange = _ref2.onChange,
      props = _objectWithoutProperties(_ref2, ["className", "color", "size", "checked", "style", "disabled", "onChange"]);

  var palette = (0, _usePalette["default"])();
  var colorClassName = "pui-checkbox--color-".concat(color);

  var elementStyle = _objectSpread({}, style);

  var handleToggle = function handleToggle() {
    if (onChange) onChange(!checked);
  };

  if (color && color !== 'inherit' && !color.startsWith('#')) {
    if (palette[color]) {
      colorClassName = "pui-checkbox--color-palette";
      elementStyle.color = palette[color][500];
    }
  }

  if (color && color.startsWith('#')) {
    colorClassName = "pui-checkbox--color-custom";
    elementStyle.color = color;
  }

  return /*#__PURE__*/_react["default"].createElement(CheckboxRoot, _extends({
    className: (0, _clsx["default"])(className, 'pui-checkbox', colorClassName, "pui-checkbox--size-".concat(size), {
      'pui-checkbox--disabled': disabled,
      'pui-checkbox--checked': checked
    }),
    style: elementStyle
  }, props), /*#__PURE__*/_react["default"].createElement(CheckboxBox, {
    checked: Boolean(checked),
    disabled: Boolean(disabled),
    onClick: handleToggle
  }));
};

Checkbox.propTypes = {
  /**
   * Is it checked?
   */
  checked: _propTypes["default"].bool,

  /**
   * Is it disabled
   */
  disabled: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  color: 'inherit',
  checked: false,
  disabled: false
};
var _default = Checkbox;
exports["default"] = _default;